export default (props) => ({
	isOpen: false,
	option: props?.option,
	currentValue: null,

	init() {
		this.select = this.$refs.select
		this.startValue = this.$refs.startValue?.value

		this.currentValue = this.startValue
	},

	toggle() {
		this.isOpen = !this.isOpen
	},

	open() {
		this.isOpen = true
	},

	close() {
		this.isOpen = false
	},

	setValue(value) {
		this.value = value
	},

	updateOption(value) {
		this.currentValue = value
	},
})
